export default __webpack_public_path__ + "static/ryan2-34ef362be2b8003b2830298b464ac446.png";